import React from "react";

export default function ArrowBack(props) {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      /* Spread props so things like className, style, etc. can be passed in */
      {...props}
    >
      <path
        /* Use "inherit" (or "currentColor") instead of a fixed color */
        fill="inherit"
        d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
      />
    </svg>
  );
}
